const SLICING = new Set(["twap", "vwap", "pov"]);
/** F12.1b: форс TWAP при крупном номинале (parity с backend auto-TWAP без стакана). */
export function applyAutoTwapProfile(profile, orderNotional, minLiquidityNotional) {
    if (SLICING.has(profile))
        return profile;
    if (minLiquidityNotional > 0 && orderNotional >= minLiquidityNotional) {
        return "twap";
    }
    return profile;
}
